import styled from '@emotion/styled';
import { Menu, TableCell } from '@mui/material';

import { colors } from '@/theme/variables';

export const BorderedCell = styled(TableCell)(() => ({
  p: {
    borderTop: `1px solid ${colors.grey[20]}`,
    borderBottom: `1px solid ${colors.grey[20]}`,
    minHeight: '40px',
    display: 'flex',
    alignItems: 'center',
    padding: '15px',
  },
  '&:first-child p ': {
    borderRadius: '8px 0 0 8px',
    borderLeft: `1px solid ${colors.grey[20]}`,
  },
  '&:last-child p ': {
    borderRadius: '0 8px 8px 0',
    borderRight: `1px solid ${colors.grey[20]}`,
  },
}));

export const KasePropertyActionMenuRoot = styled(Menu)(() => ({
  '.MuiPaper-root': {
    width: 200,
    height: 430,
    maxHeight: 'fit-content',
    overflow: 'auto',
    bottom: 0,
  },
  '.MuiMenuItem-root': {
    justifyContent: 'flex-start',
  },
  '& .sub-menu-list': {
    padding: 0,
    display: 'none',
    '.MuiMenuItem-root': {
      paddingLeft: 30,
      fontSize: 14,
    },
  },
  '& .expander-label': {
    'input[type="checkbox"]': {
      display: 'none',
    },
    svg: {
      marginLeft: 'auto',
    },
    '.icUp': {
      display: 'none',
    },
    '.icDown': {
      display: 'block',
    },
    'input[type="checkbox"]:checked ~ .MuiList-root': {
      display: 'block',
    },
    'input[type="checkbox"]:checked + .MuiMenuItem-root': {
      '.icUp': {
        display: 'block',
      },
      '.icDown': {
        display: 'none',
      },
    },
  },
}));
